import { random } from 'lodash-es'

const weightedRandom = (options: any[], weights: number[]) => {
  if (options.length !== weights.length) {
    throw new Error('Number of options does not match number of weights')
  }

  const weightsTotal = weights.reduce((acc, curr) => acc + curr)
  const randomLimit = random(0, 1, true) * weightsTotal
  let sum = 0
  let index = 0

  for (const weight of weights) {
    sum += weight
    if (randomLimit <= sum) {
      return options[index]
    }
    index++
  }
}

export default weightedRandom
